import { render, staticRenderFns } from "./ChatAuthor.vue?vue&type=template&id=9636ec54&"
import script from "./ChatAuthor.vue?vue&type=script&lang=js&"
export * from "./ChatAuthor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports